import React from 'react';
import clsx from 'clsx';

export const Button = ({ variant = 'primary', size = 'md', className, children, ...props }) => {
  const base = 'font-sans rounded-[var(--btn-radius)] inline-flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-[var(--ring)] transition-colors duration-200';
  
  const variants = {
    primary: 'bg-[var(--primary)] text-white shadow-[var(--btn-shadow)] hover:bg-[var(--primary-600)]',
    secondary: 'bg-[var(--accent)] text-white hover:bg-[var(--accent-600)]',
    ghost: 'border border-[var(--muted)] bg-white/80 text-[var(--fg)] hover:bg-[var(--muted)]',
    danger: 'bg-[var(--danger)] text-white hover:opacity-90',
  };
  
  const sizes = {
    sm: 'h-9 px-3 text-sm',
    md: 'h-10 px-4 text-sm',
    lg: 'h-11 px-6 text-base',
  };
  
  return (
    <button
      className={clsx(base, variants[variant], sizes[size], className)}
      data-testid={props['data-testid'] || 'button'}
      {...props}
    >
      {children}
    </button>
  );
};